// Modules
import { api } from "services/api/service";

// Constants
import { API_MERGE_CR_ACCOUNTS, API_CR_POINTS_EXPIRY_SUMMARY, API_CR_GET_MEMBERSHIP_STATUS, API_CR_UPDATE_MEMBERSHIP_STATUS } from "constants/api";

// Imported definitions
import type { ApiResponse, MergeCRAccountsResponse, CRPointsExpirysummaryResponse, CRGetMembershipStatusResponse, CRMembershipStatusResponse } from "services/api/types";

export const mergeCRAccounts = async (payload: { uid_to_cancel: string; uid_to_retain?: string; email_to_retain?: string }): Promise<ApiResponse<MergeCRAccountsResponse>> => {
	return (await api()).post(API_MERGE_CR_ACCOUNTS, payload);
};

export const getPointsExpirySummary = async (payload: { external_id: string }): Promise<ApiResponse<CRPointsExpirysummaryResponse>> => {
	return (await api()).post(API_CR_POINTS_EXPIRY_SUMMARY, payload);
};

export const crGetMembershipStatus = async (payload: { external_id: string }): Promise<ApiResponse<CRGetMembershipStatusResponse>> => {
	const finalPayload = {
		cr_card_number: payload.external_id,
		outlet_code: "ADMINPORTAL"
	};

	return (await api()).post(API_CR_GET_MEMBERSHIP_STATUS, finalPayload);
};

export const crUpdateMembershipStatus = async (payload: { external_id: string; new_status: string; remarks: string }): Promise<ApiResponse<CRMembershipStatusResponse>> => {
	return (await api()).post(API_CR_UPDATE_MEMBERSHIP_STATUS, payload);
};
